import { ErrorMessage as NSErrorMessage } from '@hookform/error-message';

const Message = ({ message }) => (
  <p style={{ position: 'absolute', top: 45, color: 'red', fontSize: '14px' }}>
    {message}
  </p>
);

const ErrorMessage = ({ errors, name }) => {
  return <NSErrorMessage errors={errors} name={name} render={Message} />;
};

export default ErrorMessage;
